export default [
    {
        path: 'relatorio-classificacao-risco',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-relatorio-classificacao-risco' */
            '@/views/pronto-atendimento/relatorio-classificacao-risco/Index'
        ),
        redirect: 'relatorio-classificacao-risco/index',
        children: [
            {
                name: 'pronto-atendimento-relatorio-classificacao-risco-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-relatorio-classificacao-risco' */
                    '@/views/pronto-atendimento/relatorio-classificacao-risco/List'
                ),
            },
        ]
    }
]